A single answer to a question in the questionnaire.
